import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import Button from "../../../../../../components/button";
import {getSharingDetailsPopup} from "../../../../../../../actions/sharingDetailsActions";
import {connect} from "react-redux";

class EasterEggPopup extends Component {

    constructor(props){
        super(props);

        this.closeHandler = this.closeHandler.bind(this);
    }

    closeHandler(){
        this.props.getSharingDetailsPopup([])
    }

    render() {
        return (
            <div className="p-3">
                <img className="my-5" src="/img/easter-egg-1.png" alt=""/>
                <div className="text-right">
                    <Button onClick={this.closeHandler} className="btn-primary"><span role="img" aria-label=":scream:">😱</span> {this.props.t("easterEggPopupText")}</Button>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
    }
};

export default connect(null, mapDispatchToProps)(withTranslation()(EasterEggPopup));